module.exports = __webpack_public_path__ + "static/media/about14.93cf555c.webp";